import { FormInput } from '@systemeio/ui'
import { replaceWwwForHosts } from '@systemeio/util'
import React from 'react'
import { isClient } from 'shared/components/screen-height-div'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface SubdomainInputProps {
  subdomain: string
  mainDomain?: string
  error: string
  onChange: (value: string) => void
}

const defaultMainDomain = isClient() ? `.${replaceWwwForHosts(window.location.host)}` : undefined

export const getSubdomainFromDomain = (domain: string, mainDomain = defaultMainDomain) => {
  if (!isClient() || !mainDomain) return

  return domain.split(mainDomain)?.[0]
}

export function SubdomainInput({
  subdomain,
  mainDomain = defaultMainDomain,
  error,
  onChange,
}: SubdomainInputProps) {
  const { t } = useLocoTranslation()

  return (
    <FormInput
      label={t('global.subdomain')}
      value={subdomain}
      onChange={e => onChange(e.target.value)}
      spellCheck={false}
      error={error}
      addonBefore={`${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://`}
      addonAfter={mainDomain}
    />
  )
}
